/**
 * Adverts must have at least one media row before reading platform/placement/filename.
 * Prevents render crashes when `medias` is [] or undefined (was: data?.medias[0].platform).
 */
export function advertsForWebPlacement(adverts, position) {
  if (!Array.isArray(adverts)) return [];
  return adverts.filter((ad) => {
    const m = ad?.medias?.[0];
    return m && m.platform === "web" && m.placement === position;
  });
}
